export interface SampleAutocompleteAddress {
    street: string;
    cityStateZip: string;
}

// Sample data for the EsAutocomplete docs examples: street numbers cover every
// leading digit and cities span the US, so any digits a visitor starts typing
// are likely to match several addresses. Typing "12" matches more addresses
// than the component will show, exercising the item cap and the row trim, and a
// few street lines run long for variety in suggestion width.
export const SAMPLE_LIST_OF_AUTOCOMPLETE_ADDRESSES: SampleAutocompleteAddress[] = [
    { street: '12 Maple Ave', cityStateZip: 'Cambridge, MA 02138' },
    { street: '15 Harbor Dr', cityStateZip: 'Salem, MA 01970' },
    { street: '18 Narragansett Boulevard, Unit B', cityStateZip: 'Providence, RI 02906' },
    { street: '22 Bayview Ter', cityStateZip: 'Portland, ME 04101' },
    { street: '34 Prospect St', cityStateZip: 'New Haven, CT 06511' },
    { street: '41 Franklin Ave', cityStateZip: 'Brooklyn, NY 11205' },
    { street: '55 Jefferson St', cityStateZip: 'Richmond, VA 23219' },
    { street: '62 Grove St', cityStateZip: 'Burlington, VT 05401' },
    { street: '71 Magazine St', cityStateZip: 'New Orleans, LA 70130' },
    { street: '89 Dogwood Cir', cityStateZip: 'Charlotte, NC 28205' },
    { street: '93 Sycamore St', cityStateZip: 'Columbus, OH 43206' },
    { street: '120 Elm St', cityStateZip: 'Manchester, NH 03101' },
    { street: '123 Main St', cityStateZip: 'Boston, MA 02108' },
    { street: '125 Main St', cityStateZip: 'Boston, MA 02108' },
    { street: '128 Chestnut St', cityStateZip: 'Philadelphia, PA 19106' },
    { street: '145 Highland Ave', cityStateZip: 'Somerville, MA 02143' },
    { street: '240 Walnut St', cityStateZip: 'Cincinnati, OH 45202' },
    { street: '312 Juniper Way', cityStateZip: 'Boulder, CO 80302' },
    { street: '355 Cedar Ct', cityStateZip: 'Madison, WI 53703' },
    { street: '460 Birch Ter', cityStateZip: 'Minneapolis, MN 55408' },
    { street: '512 Congress Ave', cityStateZip: 'Austin, TX 78701' },
    { street: '530 Palm Dr', cityStateZip: 'Miami, FL 33139' },
    { street: '575 Canyon Rd', cityStateZip: 'Santa Fe, NM 87501' },
    { street: '640 Aspen Way', cityStateZip: 'Denver, CO 80209' },
    { street: '725 Little Cottonwood Canyon Rd', cityStateZip: 'Salt Lake City, UT 84102' },
    { street: '812 Willow Ln', cityStateZip: 'Nashville, TN 37206' },
    { street: '845 Vine St', cityStateZip: 'Kansas City, MO 64106' },
    { street: '910 Bluff Rd', cityStateZip: 'Sioux Falls, SD 57105' },
    { street: '1024 Grand Ave', cityStateZip: 'St. Louis, MO 63106' },
    { street: '1200 Beacon St', cityStateZip: 'Brookline, MA 02446' },
    { street: '1215 Magnolia Ave', cityStateZip: 'Savannah, GA 31404' },
    { street: '1250 Lakeview Dr', cityStateZip: 'Chicago, IL 60614' },
    { street: '2124 Pine Rd', cityStateZip: 'Portland, OR 97205' },
    { street: '2650 Peachtree Industrial Blvd NE', cityStateZip: 'Atlanta, GA 30305' },
    { street: '3050 Frontier Ave', cityStateZip: 'Boise, ID 83702' },
    { street: '4120 Sunset Blvd', cityStateZip: 'Los Angeles, CA 90029' },
    { street: '4700 Martin Luther King Jr Way S', cityStateZip: 'Seattle, WA 98118' },
    { street: '6800 Ocean View Blvd', cityStateZip: 'San Diego, CA 92109' },
    { street: '7400 Mesa Trl', cityStateZip: 'Phoenix, AZ 85018' },
    { street: '9500 Desert Willow Dr', cityStateZip: 'Las Vegas, NV 89134' },
];

export const SAMPLE_LIST_OF_FRUIT = [
    'apple',
    'apricot',
    'avocado',
    'banana',
    'blackberry',
    'blueberry',
    'cantaloupe',
    'cherry',
    'clementine',
    'coconut',
    'cranberry',
    'date',
    'dragonfruit',
    'fig',
    'goji berry',
    'grape',
    'grapefruit',
    'guava',
    'honeydew melon',
    'jackfruit',
    'kiwi',
    'kumquat',
    'lemon',
    'lime',
    'lychee',
    'mango',
    'melon',
    'nectarine',
    'orange',
    'papaya',
    'passionfruit',
    'peach',
    'pear',
    'pineapple',
    'plantain',
    'plum',
    'pomegranate',
    'raspberry',
    'star fruit',
    'strawberry',
    'tamarind',
    'tangerine',
    'watermelon',
    'yuzu',
];

// most topics run long on purpose, so the docs can demonstrate the suggestion
// panel growing wider than the input when suggestions need (and the viewport
// has) the room; a few stay short for contrast
export const SAMPLE_LIST_OF_SEARCH_TERMS = [
    'battery backup for whole home power outages',
    'community solar subscription with no upfront cost',
    'electric bill rate increases in new england this winter',
    'ev charger installation cost for a garage',
    'federal solar tax credit and how to claim it',
    'heat pump cost for a 2000 square foot home',
    'heat pump installation before winter rebates expire',
    'heat pump rebates and incentives by state',
    'heat pump vs central air conditioning cost comparison',
    'heat pump water heater vs tankless gas water heater',
    'heat pumps',
    'home electrification planning for an older house',
    'how much do solar panels cost in massachusetts',
    'lease vs buy solar panels pros and cons',
    'net metering',
    'solar batteries worth it during power outages',
    'solar financing options with no money down',
    'solar installers near me with good reviews',
    'solar panel cost after the federal tax credit',
    'solar panel installation cost for a 2000 square foot home',
    'solar panel installation timeline from quote to turn on',
    'solar panels',
    'solar rebates and incentives by state',
    'ten ways to save energy and lower your electric bill',
    'virtual power plant programs that pay you',
    'whole home backup power without a gas generator',
];
